/**
 * Permission Module
 */
import router from '../../../router';
import Util from '@/util';

const state = {
  pathActions: [],
  agentMenu: [],
  nowMenuPath: null
};

const getters = {
  getPathActions: (state) => {
    let routeData = router.app.$route;
    let toPath = routeData.path;
    if (Object.keys(routeData.params).length > 0) {
      toPath = Util.pathReplace(routeData.params, toPath);
    }

    // 티켓 상세 팝업 권한 예외 처리
    if (toPath === '/operation/ticket') {
      toPath = '/ticket/ticket_details';
    }
    return state.pathActions[toPath];
  },
  getAgentMenu: (state) => {
    return state.agentMenu;
  },
  getMenuPath: (state) => {
    return state.nowMenuPath;
  }
};

const mutations = {
  setPathActions(state, statuses) {
    state.pathActions = statuses;
  },
  setMenuPath(state, nowPath) {
    state.nowMenuPath = nowPath;
  }
};

export default {
  state,
  getters,
  // actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/permission/index.js